
import Coms from '@/communications'
import bus from '@/plugins/bus'

export default {
  async getFilterSchema({ commit }, projectId) {
    try {
      const data = await Coms.filter.getUsableFilters(projectId);
      commit('setFilterSchema', data);
      return data;
    } catch (err) {
      console.error(err);
      bus.emit('notification', err, {
        color: 'error',
        dark: true
      });
      throw err; // rethrow for upstream error handling
    }
  }
}
